import { render, staticRenderFns } from "./ShiftList.vue?vue&type=template&id=4d9821ae&scoped=true&lang=pug&"
import script from "./ShiftList.vue?vue&type=script&lang=ts&"
export * from "./ShiftList.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftList.vue?vue&type=style&index=0&id=4d9821ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9821ae",
  null
  
)

export default component.exports